import { validateTransferMateCheckoutUrl } from '@common/validation-schemas';

import { completeTransferMatePayment, tmPayment } from 'services';
import { TmPaymentRequest } from 'services/payment-intl';

import { persistTransferMatePaymentReturn } from './utils';

/** Shared by standalone Finalize and the full-page handoff continuation. */
export async function startTransferMatePayment(
  payment: TmPaymentRequest,
  invalidResponseMessage: string,
  onPaymentId: (id: string) => void,
): Promise<'redirected' | 'completed'> {
  const { data } = await tmPayment(payment);
  if (!data || data.success === false || !data.paymentId) {
    throw new Error(data?.message || invalidResponseMessage);
  }
  const paymentId = String(data.paymentId);
  if (data.redirectUrl) {
    const destination = validateTransferMateCheckoutUrl(data.redirectUrl);
    persistTransferMatePaymentReturn(String(data.paymentKey || paymentId));
    onPaymentId(paymentId);
    window.location.replace(destination);
    return 'redirected';
  }
  try {
    await completeTransferMatePayment({
      transactionId: paymentId,
      status: 'successful',
    });
  } catch {
    // Completion updates the local application state only. Continue the payment flow even when
    // that best-effort update is unavailable; the payment itself was accepted by TransferMate.
  }
  onPaymentId(paymentId);
  return 'completed';
}
